import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyVisiteMedicheService
 * Client API per la sorveglianza sanitaria (visite mediche) del modulo
 * "Gestione Adempimenti Sicurezza".
 */
export default class SafetyVisiteMedicheService {
    /** Elenco visite mediche di un lavoratore (con stato calcolato). */
    static byLavoratore = (id_lavoratore) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/visite/byLavoratore`;
            ApiService.postRequest(resolve, reject, url, { id_lavoratore });
        });
    };

    /**
     * Crea una visita medica con eventuale referto (PDF).
     * @param {FormData} formData campi: id_lavoratore, data_visita, tipo_visita,
     *        giudizio_idoneita, periodicita_mesi, data_scadenza,
     *        medico_competente, prescrizioni, note, file
     */
    static create = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/visite/create`;
        return ApiService.postFormData(url, formData);
    };

    /** Elimina (soft) una visita medica. */
    static deleteVisita = (id_visita) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/visite/delete`;
            ApiService.postRequest(resolve, reject, url, { id_visita });
        });
    };

    /** Scarica il referto/giudizio (PDF) di una visita medica. */
    static download = (id_visita, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/visite/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_visita, filename });
        });
    };
}
